import CashIcon from '@atlaskit/icon/core/cash';
import * as React from 'react';

export function SvgMoney() {
  return <CashIcon label="" testId="ads-refreshed-icon" />;
}
